import React, { useState, useEffect, FormEvent } from "react";
import {
  Button,
  Input,
  FormGroup,
  Col,
  Card,
  CardBody,
  Row,
  Label,
} from "reactstrap";

import { ModalHistoricoJustificativa } from "../../components/ModalHistoricoJustificativa";

import api from "../../services/api";
import { useParams } from "react-router-dom";

import Loading from "../../components/Loading";

import { useHistory } from "react-router-dom";

import { toastr } from "react-redux-toastr";
import { AxiosError } from "axios";
import { useModalJustificativa } from "../../context/ModalJustificativaContext";

import "./styles.css";
interface justificativasProps {
  historicoDeJustificativasInseridas_arr: string[];
  id: string;
  idCryptografado: string;
  opcoesDeJustificativas: string[];
  textoDaNotificacacao: string;
  tipoDoPonto: string;
  grafico?: string;
}
interface rashProps {
  rashNotification?: string;
  isRedirect?: boolean;
}

export const FormJustificativa = ({
  rashNotification = "",
  isRedirect,
}: rashProps) => {
  const [outra, setOutra] = useState(false);
  const [userResponse, setUserResponse] = useState("");
  const [otherJustification, setOtherJustification] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [loading, setLoading] = useState(false);

  const [justificativas, setJustificativas] = useState<justificativasProps>(
    {} as justificativasProps
  );

  const { rash }: { rash: string } = useParams();
  const history = useHistory();
  const { toggleModalJustificativa } = useModalJustificativa();

  useEffect(() => {
    api.post(`/logs`, {
      url: `/justificativa/${rash ? rash : rashNotification}`,
    });
  }, [rash, rashNotification]);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    if (isSubmitting) return;

    try {
      const justification = (outra ? otherJustification : userResponse).trim();

      if (justification !== "") {
        setIsSubmitting(true);
        await api.post(
          `/justificativa/justification/${rash ? rash : rashNotification}`,
          {
            justification,
          }
        );

        toastr.info("Sucesso", "Justificativa inserida com sucesso!");
        if (isRedirect) {
          history.push(
            `/dashboard/${justificativas.tipoDoPonto.toLocaleLowerCase()}/${
              justificativas.idCryptografado
            }`
          );
        } else {
          toggleModalJustificativa();
        }
      } else {
        toastr.warning("Alerta", "Todos os campos precisam ser preenchidos!");
      }
    } catch (error) {
      const axiosError = error as AxiosError<{ message?: string }>;
      toastr.error("Error", axiosError.response?.data?.message || "Error ao inserir");
    } finally {
      setIsSubmitting(false);
    }
  }

  function selectOutro() {
    setOutra(true);
    setOtherJustification("");
  }
  useEffect(() => {
    api
      .post(`/justificativa/${rash ? rash : rashNotification}`)
      .then((response) => {
        setJustificativas(response.data);
      })
      .finally(() => setLoading(true));
  }, [rash, rashNotification]);

  return loading ? (
    <>
      <Row sm={12} style={{ justifyContent: "center" }}>
        <Card style={{ width: "50rem" }}>
          <CardBody>
            <form onSubmit={handleSubmit}>
              {justificativas.grafico && justificativas.grafico.length > 0 && (
                <Col sm={12}>
                  <img
                    src={justificativas.grafico}
                    alt="Gráfico"
                    style={{ width: "100%", display: "flex" }}
                  />
                </Col>
              )}
              <Col sm={12}>
                <p
                  style={{
                    marginLeft: -10,
                  }}
                >
                  <b>Alerta:</b>
                </p>
                <p
                  style={{
                    marginLeft: -10,
                    textAlign: "justify",
                  }}
                >
                  {justificativas.textoDaNotificacacao}
                </p>
              </Col>
              <Col
                style={{
                  display: "flex",
                  justifyContent: "right",
                }}
                sm={12}
              >
                <ModalHistoricoJustificativa
                  rashModal={rash ? rash : rashNotification}
                />
              </Col>

              <Col sm={12}>
                <p
                  style={{
                    marginLeft: -10,
                  }}
                >
                  <b>Escolha a opção que descreve o ocorrido:</b>
                </p>
              </Col>

              <FormGroup row className="ml-2">
                <Col sm={12}>
                  <div className="custom-controls-stacked">
                    {justificativas.opcoesDeJustificativas?.map(
                      (opcaoJustificativa, index) => (
                        <FormGroup>
                          <Input
                            type="radio"
                            key={index}
                            onChange={() => setOutra(false)}
                            className="radioButton"
                            id={`justificativa-${index}`}
                            name="justificativa"
                            label={opcaoJustificativa}
                            value={opcaoJustificativa}
                            onClick={() => setUserResponse(opcaoJustificativa)}
                          />
                          <Label>{opcaoJustificativa}</Label>
                        </FormGroup>
                      )
                    )}

                    <FormGroup>
                      <Input
                        type="radio"
                        className="radioButton"
                        id="justificativa-100"
                        name="justificativa"
                        label="Outra"
                        value="Outra"
                        onClick={() => selectOutro()}
                      />
                      <Label>Outra</Label>
                    </FormGroup>
                  </div>
                </Col>
                {outra && (
                  <Col sm={12}>
                    <Input
                      type="textarea"
                      className="outra"
                      id="justificativa"
                      name="justificativa"
                      required
                      value={otherJustification}
                      onChange={(e) => setOtherJustification(e.target.value)}
                      maxLength={300}
                      style={{
                        width: "100%",
                        height: "8rem",
                        fontStyle: "normal",
                        textAlign: "left",
                        margin: 0,
                        padding: 0,
                        paddingLeft: 10,
                        paddingBottom: 40,
                        justifyContent: "start",
                        marginTop: 10,
                        fontSize: "1rem",
                        overflow: "hidden",
                        resize: "none",
                      }}
                      autoFocus
                    />
                    <div
                      style={{
                        textAlign: "right",
                        fontSize: "0.85rem",
                        color: "#6c757d",
                        marginTop: 4,
                      }}
                    >
                      {otherJustification.length}/300
                    </div>
                  </Col>
                )}

                <Col sm={12}>
                  <Button
                    disabled={isSubmitting}
                    style={{
                      width: "100%",
                      backgroundColor: "#262F3D",
                      marginTop: 10,
                      alignItems: "center",
                      textAlign: "center",
                      justifyItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {isSubmitting ? "Salvando..." : "Salvar"}
                  </Button>
                </Col>
              </FormGroup>
            </form>
          </CardBody>
        </Card>
      </Row>
    </>
  ) : (
    <Loading width={10} height={10} color="primary" />
  );
};
